import { useRef, useState, useEffect } from "react";
import { useReactToPrint } from 'react-to-print';
import { useLocation } from "react-router-dom";
import { jsPDF } from "jspdf";
import "./print.css";
import "./style.css";
import { generarReporteIdentidadN2B_Jumio } from "../api/generarReporteIdentidadN2B_Jumio";
import { testDownloadFile_Jumio } from "../api/testDownloadFile_Jumio";
import Modal from 'react-bootstrap/Modal';

const N2_B_Domicilio_Jumio = () => {

    const componentRef = useRef(null);
    const isRunned = useRef(false);
    const location = useLocation();
    const params = new URLSearchParams(location.search);

    const [modalShow, setModalShow] = useState(false);
    const [show, setShow] = useState(false);
    const [showStatus, setShowStatus] = useState(null);
    const [showMessage, setShowMessage] = useState("");
    const [loading, setLoading] = useState(true);

    /*variables reporte*/

    const [usuarioDomicilioParticular, setusuarioDomicilioParticular] = useState("");
    const [usuarioDomiciliolaboral, setusuarioDomiciliolaboral] = useState("");
    const [usuarioIdentificacionContribuyente, setusuarioIdentificacionContribuyente] = useState("");
    const [usuarioNss, setusarioNss] = useState("");

    /*Datos de la persona Contribuyente*/

    const [usuarioTipoContribuyente, setUsuarioTipoContribuyente] = useState("");
    const [usuarioNumeroContribuyente, setUsuarioNumeroContribuyente] = useState("");
    const [usuarioNombreContribuyente, setUsuarioNombreContribuyente] = useState("");
    const [usuarioEmisorContribuyente, setUsuarioEmisorContribuyente] = useState("");
    const [usuarioPaisContribuyente, setUsuarioPaisContribuyente] = useState("");
    const [usuarioFechaEmitidoContribuyente, setUsuarioFechaEmitidoContribuyente] = useState("");
    const [usuarioEstatusContribuyente, setUsuarioEstatusContribuyente] = useState("");
    /*Datos de la persona NSS*/
    const [usuarioTipoNss, setUsuarioTipoNss] = useState("");
    const [usuarioNumeroNss, setUsuarioNumeroNss] = useState("");
    const [usuarioNombreNss, setUsuarioNombreNss] = useState("");
    const [usuarioEmisorNss, setUsuarioEmisorNss] = useState("");
    const [usuarioPaisNss, setUsuarioPaisNss] = useState("");
    const [usuarioFechaEmitidoNss, setUsuarioFechaEmitidoNss] = useState("");
    const [usuarioEstatusNss, setUsuarioEstatusNss] = useState("");
    /*Alertas de probidad*/
    const [usuarioTextoAlertasFinancieras, setUsuarioTextoAlertasFinancieras] = useState("");
    const [usuarioVeredictoAlertasFinancieras, setUsuarioVeredictoAlertasFinancieras] = useState("");
    /*Footer */
    const [usuarioFooter, setUsuarioFooter] = useState("");
    /*Documentos Presentados*/
    const [usuarioFrontalDocumento, setUsuarioFrontalDocumento] = useState("");
    const [usuarioRerversoDocumento, setUsuarioRerversoDocumento] = useState("");

    const [selfie, setSelfie] = useState("");
    const [cardSvgP, setCardSvgP] = useState("");
    const [logoDPR, setLogoDPR] = useState("");
    const [check_deepBlue, setCheck_deepBlue] = useState("");
    const [cardSvgBlack, setCardSvgBlack] = useState("");
    const [userExample, setUserExample] = useState("");
    const [fakeExample, setFakeExample] = useState("");
    const [fakeExample2, setFakeExample2] = useState("");
    const [qr, setQr] = useState("");

    /*---Nombre reporte---*/

    const date = new Date();
    const formattedDate = date.toLocaleDateString('en-GB', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
    }).split('/').reverse().join('-');
    const [cpv, setCpv] = useState(params.get("i"));

    /*-----------------------------------*/

    const [vigencia, setVigencia] = useState("");
    const [telefonoFijo, setTelefonoFijo] = useState("");
    const [telefonoFijoLaboral, setTelefonoFijoLaboral] = useState("");
    const [domicilioParticularDireccion, setDomicilioParticularDireccion] = useState("");
    const [domicilioLaboralDireccion, setDomicilioLaboralDireccion] = useState("");
    const [domicilioParticularImagen, setDomicilioParticularImagen] = useState("");
    const [domicilioLaboralImagen, setDomicilioLaboralImagen] = useState("");
    const [domicilioParticularEstatus, setDomicilioParticularEstatus] = useState("");
    const [domicilioLaboralEstatus, setDomicilioLaboralEstatus] = useState("");
    const [identificacionContribuyenteEstatus, setIdentificacionContribuyenteEstatus] = useState("");
    const [nssEstatus, setNssEstatus] = useState("");
    const [numeroAlertasRiesgo, setNumeroAlertasRiesgo] = useState("");
    const [tipoComprobante, setTipoComprobante] = useState("");
    const [numeroComprobante, setNumeroComprobante] = useState("");
    const [nombreComprobante, setNombreComprobante] = useState("");
    const [emisorComprobante, setEmisorComprobante] = useState("");
    const [paisComprobante, setPaisComprobante] = useState("");
    const [fechaEmitidoComprobante, setFechaEmitidoComprobante] = useState("");
    const [estatusComprobante, setEstatusComprobante] = useState("");
    const [porcentajeDomicilios, setPorcentajeDomicilios] = useState("");
    const [botonTendenciaDomicilios, setBotonTendenciaDomicilios] = useState("");
    const [showPrint, setShowPrint] = useState(false);
    const Ref = useRef(null);

    const handleClose = () => {
        setShow(false);
    }

    const rotateImage = (imageSrc, angle) => {
        return new Promise((resolve) => {
            const img = new Image();
            img.src = imageSrc;

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');

                if (angle === 90 || angle === 270) {
                    canvas.width = img.height;
                    canvas.height = img.width;
                } else {
                    canvas.width = img.width;
                    canvas.height = img.height;
                }

                ctx.translate(canvas.width / 2, canvas.height / 2);
                ctx.rotate((angle * Math.PI) / 180);
                ctx.drawImage(img, -img.width / 2, -img.height / 2);

                resolve(canvas.toDataURL());
            };
        });
    }

    useEffect(() => {

        if (isRunned.current) return;
        isRunned.current = true;

        async function createSession() {

            const objCpv = {
                cpv: params.get("i"),
            };

            const response = await generarReporteIdentidadN2B_Jumio(objCpv);

            if (response.status === 200) {

                /** ----------------------------------------------------------------------------------*/

                const cardSvgPStr =
                    "data:image/png;base64," + response.cardSvgP + "";

                const logoDPRStr =
                    "data:image/png;base64," + response.logoDPR + "";

                const check_deepBlueStr =
                    "data:image/png;base64," + response.check_deepBlue + "";

                const cardSvgBlackStr =
                    "data:image/png;base64," + response.cardSvgBlack + "";

                const qrStr =
                    "data:image/png;base64," + response.qr + "";

                /** -------------------------  Imagen de domicilio, laboral------------------------  */

                const objAWSImage = {
                    img: "Mapa1_" + params.get("i") + "_1.png",
                };

                const dataImgAWS = await testDownloadFile_Jumio(objAWSImage);

                const imagenStrFrontID =
                    "data:image/png;base64," + dataImgAWS.img + "";

                setDomicilioParticularImagen(imagenStrFrontID);

                /** ----------------------------------------------------------------------------------*/

                const objAWSImageLab = {
                    img: "Mapa2_" + params.get("i") + "_1.png",
                };

                const dataImgAWSLab = await testDownloadFile_Jumio(objAWSImageLab);

                const imagenStrLabID =
                    "data:image/png;base64," + dataImgAWSLab.img + "";

                setDomicilioLaboralImagen(imagenStrLabID);

                /** ----------------------------------------------------------------------------------*/

                const objAWSImageNss = {
                    img: "Nss_" + params.get("i") + "_1.png",
                };

                const dataImgAWSNss = await testDownloadFile_Jumio(objAWSImageNss);

                const imagenStrNss =
                    "data:image/png;base64," + dataImgAWSNss.img + "";

                rotateImage(imagenStrNss, 360).then((rotatedImage) => {
                    setUsuarioRerversoDocumento(rotatedImage);
                });

                /** ----------------------------------------------------------------------------------*/


                const objAWSImageComprobante = {
                    img: "Comprobante_" + params.get("i") + "_1.png",
                };

                const dataImgAWSComprobante = await testDownloadFile_Jumio(objAWSImageComprobante);

                const imagenStrComprobante =
                    "data:image/png;base64," + dataImgAWSComprobante.img + "";

                rotateImage(imagenStrComprobante, 360).then((rotatedImage) => {
                    setUsuarioFrontalDocumento(rotatedImage);
                });

                /** ----------------------------------------------------------------------------------*/

                setLogoDPR(logoDPRStr);
                setCardSvgP(cardSvgPStr);
                setCheck_deepBlue(check_deepBlueStr);
                setCardSvgBlack(cardSvgBlackStr);
                setQr(qrStr);

                setCpv(response.cpv);
                setVigencia(response.vigencia);
                setTelefonoFijo(response.telefonoFijo);
                setTelefonoFijoLaboral(response.telefonoFijoLaboral);
                setDomicilioParticularDireccion(response.domicilioParticularDireccion);
                setDomicilioLaboralDireccion(response.domicilioLaboralDireccion);

                setDomicilioParticularEstatus(response.domicilioParticularEstatus);
                setDomicilioLaboralEstatus(response.domicilioLaboralEstatus);
                setIdentificacionContribuyenteEstatus(response.identificacionContribuyenteEstatus);
                setNssEstatus(response.nssEstatus);
                setNumeroAlertasRiesgo(response.numeroAlertasRiesgo);

                setTipoComprobante(response.tipoComprobante);
                setNumeroComprobante(response.numeroComprobante);
                setNombreComprobante(response.nombreComprobante);
                setEmisorComprobante(response.emisorComprobante);
                setPaisComprobante(response.paisComprobante);
                setFechaEmitidoComprobante(response.fechaEmitidoComprobante);
                setEstatusComprobante(response.estatusComprobante);

                setUsuarioTipoContribuyente(response.tipoContribuyente);
                setUsuarioNumeroContribuyente(response.numeroContribuyente);
                setUsuarioNombreContribuyente(response.nombreContribuyente);
                setUsuarioEmisorContribuyente(response.emisorContribuyente);
                setUsuarioPaisContribuyente(response.paisContribuyente);
                setUsuarioFechaEmitidoContribuyente(response.fechaEmitidoContribuyente);
                setUsuarioEstatusContribuyente(response.estatusContribuyente);

                setUsuarioTipoNss(response.tipoNss);
                setUsuarioNumeroNss(response.numeroNss);
                setUsuarioNombreNss(response.nombreNss);
                setUsuarioEmisorNss(response.emisorNss);
                setUsuarioPaisNss(response.paisNss);
                setUsuarioFechaEmitidoNss(response.fechaEmitidoNss);
                setUsuarioEstatusNss(response.estatusNss);
                setUsuarioTextoAlertasFinancieras(response.textoAlertasFinancieras);

                setPorcentajeDomicilios(response.porcentajeDomicilios);
                setUsuarioVeredictoAlertasFinancieras(response.veredictoAlertasFinancieras);
                setUsuarioFooter(response.footer);
                setBotonTendenciaDomicilios(response.botonTendenciaDomicilios);

                handlePrint();

            } else {

                setLoading(false);
                setModalShow(false);
                setShow(true);
                setShowStatus(500);
                setShowMessage("Error al generar Reporte");

            }

        }

        createSession();

    }, []);



    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
        print: async () => {
            const doc = new jsPDF();
            doc.html(componentRef.current, {
                html2canvas: {
                    removeContainer: true,
                    scale: 0.19,
                },
                margin: 5,
                x: -1,
                async callback(doc) {
                    await doc.save('Reporte AccesibilidadFisica_' + cpv + '_' + formattedDate);
                },
            });
        },

    });

    return (
        <>
            <Modal show={show} onHide={handleClose} animation={false} centered>
                <Modal.Body className='backGroudModal'>
                    <div className='msjTitleModalDiv'>Error {showStatus}</div>
                    <div className='msjErrorModal'>{showMessage}</div>
                </Modal.Body>
                <Modal.Footer>
                    <button className='button_P2' onClick={handleClose}>
                        <span className='txtButton_P2'>Regresar</span>
                    </button>
                </Modal.Footer>
            </Modal>

            <div className="w-100  justify-content-center" style={{ display: "flex", width: "965px", border: "none" }}>
                <div
                    className=" animate__animated animate__fadeIn"
                    ref={componentRef}
                    style={{ display: "block", width: "1070px", border: "none" }}
                >
                    <div className="relativeCSS">
                        <style type="text/css" media="print">
                            {
                                "@page {  size: A4;  }"
                            }
                        </style>


                        {/* hoja 1 */}
                        <br />
                        <div className="container-fluid">
                            <section className="row">
                                <div className="col-6">
                                    <article className="identify-card ">
                                        <aside className="account-detail gray w25">
                                            <section className="detail-image">
                                                <img src={logoDPR} alt="" />
                                            </section>
                                            <div className="detail-background">
                                                <img src={cardSvgP} alt="" width={'75%'} height={'auto'} />
                                            </div>
                                        </aside>
                                        <article className="middle-section">
                                            <title className="title">
                                                <div className="left">IDe</div>
                                                <div className="right">
                                                    <strong>IDENTIDAD ELECTRÓNICA</strong>
                                                    <br />
                                                    <span>CREDENCIAL VERIFICABLE</span>
                                                </div>
                                            </title>
                                            <section className="info-section gray">
                                                <div className="subtitle">
                                                    <span>PROCESO &nbsp; DE CERTIFICACIÓN</span>
                                                    <h2>Identidad</h2>
                                                    <h4>Nivel 2</h4>
                                                </div>
                                                <hr className="bordeHr" />
                                                <ul className="pNone">
                                                    <li>
                                                        <img src={check_deepBlue} alt="checkBlue" />
                                                        <span>AUTENTICACIÓN &nbsp; DE IDENTIDAD</span>
                                                    </li>
                                                    <li>
                                                        <img src={check_deepBlue} alt="checkBlue" />
                                                        <span>DOCUMENTACIÓN &nbsp; PROBATORIA</span>
                                                    </li>
                                                    <li>
                                                        <img src={check_deepBlue} alt="checkBlue" />
                                                        <span>ALERTAS &nbsp; DE PROBIDAD</span>
                                                    </li>
                                                </ul>
                                                <div className="expires">
                                                    <span className="text-lg">Vence: {vigencia}</span>
                                                </div>
                                            </section>
                                        </article>
                                        <article className="right-section">
                                            <div className="detail-finance identity">
                                                <img src={cardSvgBlack} alt="" className="w50px" />
                                            </div>
                                            <section className="qr-code">
                                                <img className="w50px" src={qr} alt="" />
                                                <span className="cpv__text">CPV&nbsp;: {cpv}</span>
                                            </section>
                                            <section className="verify">
                                                <img src={cardSvgP} alt="" />
                                            </section>
                                        </article>
                                    </article>

                                    <br />

                                    <div className="titleCard">Verificación &nbsp; de autenticidad</div>
                                    <div className="card verify-note">
                                        <p className="f12"> El resultado obtenido  <strong> no es válido </strong> si la fecha en la parte superior izquierda de este
                                            <strong> Reporte </strong> se encuentra <strong> vencida </strong> . Para comprobar su autenticidad escanee el código QR o ingrese directamente el código
                                            <strong> CPV </strong> en <strong> www.midpr.net/verificar </strong> .
                                        </p>
                                    </div>
                                    <small className="footer-note">
                                        *Notifique si este Reporte es falso al +52 5571605526 y/o en www.midpr.net
                                    </small>
                                </div>
                                <div className="col-6">
                                    <h4 className="text-center ">Accesibilidad Física</h4>

                                    <p className="f12">
                                        Este <strong>&nbsp; Reporte </strong>
                                        da constancia de la calificación resultante de la aplicación de manera
                                        <strong> completa y concluyente </strong>
                                        de esta Evaluación Remota Confiable (&nbsp; ERC &nbsp;) realizada por el
                                        <strong> Aplicante </strong>
                                        , obteniendo los siguientes resultados:
                                    </p>

                                    <div className="titleCard">Resultado &nbsp; obtenido</div>
                                    <article className="card digital-data">
                                        <table>
                                            <tbody>
                                                <tr className="dataResulObj">{usuarioDomicilioParticular}</tr>
                                                <tr className="dataResulObj"><span>Domicilio particular: <strong>{domicilioParticularEstatus}</strong></span></tr>
                                                <tr className="dataResulObj">{usuarioDomiciliolaboral}</tr>
                                                <tr className="dataResulObj"><span>Domicilio laboral: <strong>{domicilioLaboralEstatus}</strong></span></tr>
                                                <tr className="dataResulObj">{usuarioIdentificacionContribuyente}</tr>
                                                <tr className="dataResulObj"><span>Identificación de contribuyente: <strong>{identificacionContribuyenteEstatus}</strong></span> </tr>
                                                <tr className="dataResulObj">{usuarioNss}</tr>
                                                <tr className="dataResulObj"><span>Número de Seguridad Social: <strong>{nssEstatus}</strong></span></tr>
                                            </tbody>
                                        </table>
                                        <div className="d-flex justify-content-center  align-items-center">
                                            <button type="button" className="inter">{`Alertas de riesgo ${numeroAlertasRiesgo}`}</button>
                                        </div>
                                    </article>
                                    <small className="footer-note ">
                                        *La interpretación de este resultado obtenido es responsabilidad exclusiva de quien lo recibe.
                                    </small>
                                </div>
                            </section>
                        </div>

                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-6 personal-data">

                                    <div className="titleCard">COMPROBACIÓN &nbsp; DOMICILIAR</div>
                                    <section className="card  container-fluid ">
                                        <div className="row">
                                            <div className="container-fluid">
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="text-start">
                                                            <h6 className="text__spacing"> Domicilio particular</h6>
                                                        </div>
                                                        <div className="d-flex justify-content-center">
                                                            <img src={domicilioParticularImagen} alt="imagenLaboral" className="img__map" />
                                                        </div>

                                                        <div className="personal-info">
                                                            <address className="mb-0">Dirección&nbsp;: {domicilioParticularDireccion}
                                                            </address>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="text-start ">
                                                            <h6 className="text__spacing"> Domicilio laboral</h6>
                                                        </div>
                                                        <div className="d-flex justify-content-center">
                                                            <img src={domicilioLaboralImagen} alt="imagenLaboral" className="img__map" />
                                                        </div>

                                                        <div className="personal-info">
                                                            <address className="mb-0">Dirección&nbsp;: {domicilioLaboralDireccion}
                                                            </address>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="row">
                                                    <div className="col-12">

                                                        <div className="personal-info text-end px-3 w-100" >
                                                            <address className="mb-0">{porcentajeDomicilios}</address>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    {botonTendenciaDomicilios !== 0 ? (
                                        <>
                                            {botonTendenciaDomicilios > 50 ? (
                                                <>
                                                    <div>
                                                        <div className=" d-flex justify-content-center align-items-center">
                                                            <button type="button" className="btn green trend">TENDENCIA &nbsp; A &nbsp; CONSISTENTE</button>
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (
                                                <>
                                                    <div>
                                                        <div className=" d-flex justify-content-center align-items-center">
                                                            <button type="button" class="btn yellow trend">TENDENCIA &nbsp; A INCONSISTENTE</button>
                                                        </div>
                                                    </div>
                                                </>
                                            )}

                                        </>
                                    ) : (
                                        <>
                                            <div>
                                                <div className=" d-flex justify-content-center align-items-center">
                                                    <button type="button" class="btn yellow trend">TENDENCIA &nbsp; A INCONSISTENTE</button>
                                                </div>
                                            </div>
                                        </>
                                    )}

                                    <small className="footer-note">*Consulte definiciones de estas métricas en www.midpr.net/resultados</small>
                                    <p className="f12">
                                        Esta <strong> &nbsp;IDe </strong>
                                        fue realizada de manera automatizada a través de un dispositivo digital propiedad del
                                        <strong> Aplicante </strong>
                                        . Durante el proceso, se registraron una serie de datos de carácter personal que fueron analizados, validados y/o verificados que permitieron, posterior al análisis de la información, la obtención del dictamen presentado con respecto a la consistencia o inconsistencia de estos de manera integral.

                                    </p>
                                </div>
                                <div className="col-6 ">
                                    <div className="titleCard">DOCUMENTACIÓN &nbsp; PROBATORIA</div>
                                    <div className="card probation Word__Spacing">
                                        <p>{tipoComprobante}</p>
                                        <address className="f14">
                                            <div>Número &nbsp;<strong>{numeroComprobante}</strong></div>
                                            <div>Nombre&nbsp;:&nbsp; {nombreComprobante}</div>
                                            <div>Emisor&nbsp;:&nbsp; {emisorComprobante}</div>
                                            <div>País&nbsp;:&nbsp; {paisComprobante}</div>
                                            <div>Vigencia&nbsp;:&nbsp; {fechaEmitidoComprobante}</div>
                                            <div>Estatus&nbsp;:&nbsp; {estatusComprobante}</div>
                                        </address>
                                        <p>{usuarioTipoContribuyente}</p>
                                        <address className="f14">
                                            <div>Número&nbsp;: &nbsp;<strong>{usuarioNumeroContribuyente}</strong></div>
                                            <div>Nombre&nbsp;:&nbsp; {usuarioNombreContribuyente}</div>
                                            <div>Emisor&nbsp;:&nbsp; {usuarioEmisorContribuyente}</div>
                                            <div>País&nbsp;:&nbsp; {usuarioPaisContribuyente}</div>
                                            <div>Estatus&nbsp;:&nbsp; {usuarioEstatusContribuyente}</div>
                                        </address>
                                        <p>{usuarioTipoNss}</p>
                                        <address className="f14">
                                            <div>Número&nbsp;: &nbsp;<strong>{usuarioNumeroNss}</strong></div>
                                            <div>Nombre&nbsp;:&nbsp; {usuarioNombreNss}</div>
                                            <div>Emisor&nbsp;:&nbsp; {usuarioEmisorNss}</div>
                                            <div>País&nbsp;:&nbsp; {usuarioPaisNss}</div>
                                            <div>Estatus&nbsp;:&nbsp; {usuarioEstatusNss}</div>
                                        </address>
                                    </div>
                                    <small className="footer-note">*Consulte al reverso de este Reporte las imágenes recabadas.</small>
                                    <div className="titleCard">ALERTAS &nbsp; DE PROBIDAD</div>
                                    <section className="card family-income">
                                        <p className="f11"> {usuarioTextoAlertasFinancieras} </p>
                                        <h6><strong>{usuarioVeredictoAlertasFinancieras}</strong></h6>
                                    </section>
                                </div>
                            </div>
                        </div>

                        <section className="note-gray note-emit">
                            <p className="Footer__font--weigth">
                                {usuarioFooter}
                            </p>

                        </section>
                        <small className="footer-note">*Consulte al reverso de este Reporte DPR &nbsp; nuestra Política de Privacidad y/o en www.midpr.net/privacidad</small>
                        <div>AVISO &nbsp; LEGAL</div>
                        <div class="card legal-advise">
                            <p className="f12">La <strong> Calificación </strong> realizada de manera remota por el <strong>Aplicante</strong>, a la que hace referencia este <strong>Reporte</strong>, fue realizada a solicitud directa del <strong>Destinatario</strong>. Antes y durante la <strong>Calificación</strong>, fue autenticada la identidad del <strong>Aplicante</strong> y se registraron una serie de datos e información de carácter personal con su autorización expresa, lo cual permitió emitir una Evaluación Remota Confiable (&nbsp; ERC &nbsp;). El <strong>Destinatario</strong> acepta que todos los datos contenidos en el presente <strong>Reporte</strong> son confidenciales y de interés exclusivo y privado, que es compartida únicamente con el propósito que ha sido previamente informado por el <strong>Destinatario</strong> y que ha autorizado por el <strong>Aplicante</strong> previo a la aplicación de la <strong>Calificación</strong>. El <strong>Aplicante</strong> y/o el <strong>Destinatario</strong> de este Reporte aceptan de conformidad la responsabilidad sobre cualquier uso indebido o ilegal de este documento y su contenido, así como todos los términos y condiciones descritos al reverso. <strong>Una vez entregado este Reporte al Destinatario, el Fabricante se deslinda de toda responsabilidad sobre su interpretación, divulgación y uso</strong>.</p>
                            <br />
                        </div>
                        <br />
                        <p class="txt-center f12"><strong>Business &nbsp; Prey SA de CV</strong> hace referencia que con número de registro <strong>DGSP&nbsp;/369-19/3919</strong>, está autorizada por la <strong>SSPC&nbsp;/DGSP</strong> para la aplicación de Pruebas y Evaluación de Control de Confianza de conformidad con los <strong>Lineamientos y Criterios Técnicos&nbsp;</strong> publicados en el Diario Oficial de la Federación (DOF) el <strong>28 de abril de 2020</strong>.</p>


                        {/* Hoja 2 */}

                        <br />
                        <br />
                        <br />
                        <div className="Documetos__size--padding">
                            <h5 className="text-start">DOCUMENTOS &nbsp; PRESENTADOS</h5>
                            <div className="card presented ">

                                <img src={usuarioFrontalDocumento} alt="" className="w-100 newImageFormat" />

                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                            <div className="card presented ">
                                <img src={usuarioRerversoDocumento} alt="" className="w-100 newImageFormat" />
                            </div>
                        </div>

                        <br />
                        <br />
                        <br />
                        <br />
                        <br />
                        <br />

                        <div className="div-vertical">
                            <div className="div-horizontal" id="div1">

                                <div className="mt-4">

                                    <div className="container-fluid">

                                        <div className="row">
                                            <div className="col-6 Info__row">
                                                <p>
                                                    <strong>Privacidad de Datos Personales</strong>
                                                    <br />
                                                    Para &nbsp; efectos
                                                    del cumplimiento del artículo 9 de la Ley Federal de Protección de
                                                    Datos Personales en Posesión de los Particulares (LFPDPPP &nbsp;), el
                                                    Aplicante de la ERC &nbsp; manifiesta expresamente que otorgó su
                                                    consentimiento para el tratamiento de sus datos personales
                                                    sensibles, durante los procedimientos de recopilación y
                                                    procesamiento, aceptando los términos y condiciones para tales
                                                    efectos.
                                                </p>
                                                <p>
                                                    <strong>Uso de las Marcas</strong>
                                                    <br />
                                                    DPR &nbsp; y las marcas asociadas
                                                    son marcas registradas, protegidas por los artículos 88 y 142 de
                                                    la Ley de Propiedad Industrial (LPI &nbsp;), así como el convenio de
                                                    París para efectos internacionales. El consumo o adquisición de
                                                    cualquiera de los servicios vinculados a DPR &nbsp; y/o proporcionados
                                                    por el Fabricante, no confieren al Aplicante y/o al Destinatario
                                                    el derecho de uso de las marcas de DPR &nbsp; en ningún contexto y/o
                                                    formato, ya que al hacerlo podría resultar en actividad
                                                    fraudulenta y ser clasificado como un delito.
                                                </p>
                                                <p>

                                                    <strong>Uso de Información por Terceros</strong>
                                                    <br />
                                                    Al realizar
                                                    la IDe, el Aplicante autoriza la entrega de los datos obtenidos al
                                                    Destinatario para el uso particular que ambos hayan acordado.
                                                </p>
                                                <p>
                                                    <strong>En DPR estamos a favor de la confianza profesional, la
                                                        honestidad y transparencia, la privacidad de datos personales,
                                                        la equidad de género, la inclusión financiera y digital, la
                                                        igualdad de oportunidades y la no discriminación.</strong>
                                                </p>
                                            </div>
                                            <div className="col-6 Info__row column-interesting">
                                                <h5>TEMAS &nbsp; DE &nbsp; INTERÉS</h5>
                                                <div className="card interesting">
                                                    <ul>
                                                        <li>
                                                            <strong>Domicilio Particular:</strong> Dirección particular (verificada),teléfono fijo (recabado),
                                                            comprobante de domicilio (recabado)
                                                        </li>
                                                        <li>
                                                            <strong>Domicilio laboral:</strong> Dirección laboral (verificada), teléfono fijo (recabado).
                                                        </li>
                                                        <li>
                                                            <strong>Comprobación domiciliar:</strong> Coordenadas decimales (validadas), presencia
                                                            digital (estimada).
                                                        </li>
                                                        <li>
                                                            <strong>Alertas financieras:</strong> Exposición política (PEP &nbsp;), boletines financieros.
                                                            círculo social.
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <br />
                                    <br />
                                    <div className="note-gray">
                                        <p>
                                            <strong>Business &nbsp; Prey SA de CV</strong> con domicilio en
                                            Alfonso Reyes &nbsp; 216 Dep L003, Col. Hipódromo, C.P. 06100 Alcaldía Cuauhtémoc, CDMX, México, es Fabricante exclusivo de
                                            DPR. Para mayor información llame al +52 5571605526 o
                                            visite el sitio <strong>www.midpr.net</strong>.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default N2_B_Domicilio_Jumio